<template>
  <div class="mb-10">
    <HeaderBar :title="hTitle" />
    <div>
      <div class="my-2">The following will be provided by Moldex directly to the bank.</div>

      <ul>
        <li>1. Notarized Contract to Sell</li>
        <li>2. Certificate of Outstanding Balance</li>
        <li>3. Copy of Title under Moldex</li>
      </ul>
    </div>
  </div>
</template>

<script>
import HeaderBar from "../../../components/HeaderBar.vue";
export default {
  components: { HeaderBar },
  props: ["hTitle"],
};
</script>